import pxToRem from 'assets/theme/function/px-to-rem';
import { breakpoints } from 'assets/theme/base/breakpoints';

const dialogActions = {
    styleOverrides: {
        root: {
            paddingTop: pxToRem(10),
            paddingBottom: pxToRem(25),
            paddingLeft: pxToRem(90),
            paddingRight: pxToRem(90),

            [breakpoints.down('md')]: {
                paddingLeft: pxToRem(40),
                paddingRight: pxToRem(40),
            },

            [breakpoints.down('sm')]: {
                paddingBottom: pxToRem(20),
                paddingLeft: pxToRem(10),
                paddingRight: pxToRem(10),
            },
        },
    },
};

export default dialogActions;
